import {FC} from 'react'
import {Link} from 'react-router-dom'

const ErrorInvalidToken: FC = () => {
  return (
    <div 
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f8f9fa',
        margin: 0,
        padding: 0,
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        left: 0
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: '600px', padding: '20px' }}>
        <h1 style={{ 
          fontSize: '2.5rem', 
          fontWeight: 'bold', 
          color: '#333', 
          marginBottom: '20px' 
        }}>
          Invalid or Expired Link
        </h1>

        <p style={{ 
          fontSize: '1.2rem', 
          color: '#666', 
          marginBottom: '30px',
          lineHeight: '1.5'
        }}>
          The portfolio link you've accessed is no longer valid or has expired. 
          Please contact the portfolio owner for a new link.
        </p>

        {/* <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
          <Link 
            to='/' 
            style={{
              display: 'inline-block',
              padding: '12px 24px',
              backgroundColor: '#007bff',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '4px',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            Go to homepage
          </Link>
          <Link 
            to='/login' 
            style={{
              display: 'inline-block',
              padding: '12px 24px',
              backgroundColor: '#6c757d',
              color: 'white',
              textDecoration: 'none',
              borderRadius: '4px',
              fontSize: '16px',
              fontWeight: 'bold'
            }}
          >
            Sign in
          </Link>
        </div> */}
      </div>
    </div>
  )
}

export {ErrorInvalidToken}
